import type { GameProfile } from '../types';

const GREEN = '#2E7D32';
const BLUE = '#2C4F8C';
const YELLOW = '#E5C920';
const RED = '#BC4435';

export const ball12: GameProfile = {
  id: 'ball-12',
  label: '12 Balls (1–12)',
  ballIds: Array.from({ length: 12 }, (_, i) => i + 1),
  colorFor: (id) => {
    if (id <= 3) return GREEN;
    if (id <= 6) return BLUE;
    if (id <= 9) return YELLOW;
    return RED;
  },
  textureStyle: 'standard',
  machineCount: 1,
  resultsPerDraw: 1,
};
